// UX G2: Nicht gefunden (je Plattform in ihrer Shell).
import { Link } from 'react-router';

export function NotFound() {
  return (
    <section data-ready="true" className="py-16 text-center">
      <h1 className="text-display text-fg">Page not found</h1>
      <p className="mt-2 text-body text-fg-secondary">
        The page you are looking for does not exist or was moved.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-control items-center rounded-full bg-primary px-4 text-button text-on-primary"
      >
        Go home
      </Link>
    </section>
  );
}
